import React, {Component} from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./pilot.css";
import "./pilot-rwd.css"
import {DataService} from "./services/DataService";
import {Spinner} from "react-bootstrap";
import {PilotListPage} from "./Pages/PilotListPage";
import PilotExhibitionStatePage from "./Pages/PilotExhibitionStatePage";

class PilotStandardPage extends Component {

    state = {
        loading: false,
        data: {}
    }

    componentDidMount() {
        DataService.getDataJsonFile().then(
            (res) => {
                this.setState({
                    data: res,
                    loading: true
                });
            }
        )
    }

    render() {
        const { data, loading } = this.state;

        return (
            loading ? (
                <div className="pilot-wrapper">
                    {/*header*/}
                    <div className="pilot-header">
                        <div className="pilot-logo">
                            <img className="img-logo" alt="HiLight" src="/assets/pilot/hilight-logo.png" />
                        </div>
                        <div className="pilot-title-bar d-none d-md-flex">
                            <h1 dangerouslySetInnerHTML={{__html: data.title}}></h1>
                        </div>

                        <div className="pilot-actions">

                        </div>
                    </div>
                    {/*end header*/}

                    {/*body*/}
                    <div className="pilot-body">
                        <PilotExhibitionStatePage data={data}/>
                    </div>
                    {/*end body*/}

                    {/*footer*/}
                    <div className="pilot-footer">
                        Copyright by HiLight 2024
                    </div>
                    {/*end footer*/}
                </div>
            ) : (<Spinner animation={"border"} />)
        )
    }
}
export default PilotStandardPage
